module.exports = __webpack_public_path__ + "img/ac6_thumb.38eeb98f.jpg";